import React, {useState} from 'react';
import AsyncSelect from 'react-select/async';
import {components} from 'react-select';
import {RiArrowDownSFill} from "react-icons/ri";

function SearchDropDown(props) {
    const [selectedValue, setSelectedValue] = useState(null);
    let timeoutId;

    const customStylesError = {
        control: (provided, state) => ({
            ...provided, border: '1px solid red',
            height:'10%'
        }),
    }

    // handle selection
    const handleChange = value => {
        props.setOrganizationId(value.id);
        props.setSiteFilter([]);
        props.setIsOrganizationSelected(true);
        setSelectedValue(value);
    }
    const handleInputChange = () => {
        clearTimeout(timeoutId);
        props.setShowPopup(false);
    }

    // load options using API call
    const loadOptions = (inputValue, callback) => {
        const options = [];
        if (inputValue.length < 2) {
            callback(options);
            return;
        }
        timeoutId = setTimeout(() => {
            props.monitoringService.getOrganizations(inputValue)
                .then((response) => {
                    response.data.forEach((obj) => {
                        options.push({
                            title: obj.label, id: obj.id,
                        });
                    });
                    callback(options);
                });
        }, 750);
    }

    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    return (<>
        <AsyncSelect
            cacheOptions
            defaultOptions
            value={selectedValue}
            getOptionLabel={e => e.title}
            getOptionValue={e => e.id}
            loadOptions={loadOptions}
            styles={props.showPopup ? customStylesError : {}}
            onInputChange={handleInputChange}
            placeholder={'Search...'}
            onChange={handleChange}
            components={{
                IndicatorSeparator: () => null, DropdownIndicator
            }}
        />
    </>);
}

export default SearchDropDown;
